import gql from 'graphql-tag'

export const GET_USER_AUTHENTICATED = gql`
  query {
    me: meHero {
      id
      active
      heroType
      name
      firstname
      lastname
      tel
      address
      subDistrict
      district
      province
      zipcode
      email
      lineId
      maxLocation
      radius
      configByHero
      plateLicense
      purpose
      postalAddress
      avatar {
        id
        url
      }
      pictures {
        id
        url
      }
      idCard {
        id
        url
      }
      products {
        id
        minQuantity
        price
        material {
          id
          name
          baseMaterial
          cover {
            id
            url
          }
          images {
            id
            url
          }
        }
      }
      status
      locations {
        id
        lat
        lng
        address
        radius
      }
    }
    heroConfigs {
      id
      heroType
      locationCount
      radius
    }
    categories {
      id
      name
      materials {
        id
        name
        baseMaterial
        cover {
          id
          url
        }
        images {
          id
          url
        }
      }
    }
    options: __type(name: "MinQuantity") {
      quantityOptions: enumValues {
        name
      }
    }
  }
`

export const GET_OPTIONS = gql`
  query {
    options: __type(name: "HeroType") {
      heroTypeOptions: enumValues {
        name
      }
    }
  }
`

export const GET_HERO_NEWS_LIST = gql`
  query GetHeroNewsList {
    heroNewsItems {
      id
      name
      url
      enabled
      image {
        id
        name
        url
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/graphql/queries/Auth.js